import { render, staticRenderFns } from "./UnpickedOrdersReport.vue?vue&type=template&id=a6676588"
import script from "./UnpickedOrdersReport.vue?vue&type=script&lang=js"
export * from "./UnpickedOrdersReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fviews%2Freports%2Funpicked-orders-report%2FUnpickedOrdersReport.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports